require('./warnAboutDeprecatedCJSRequire.js')('router');

module.exports = require('react-router-dom');
module.exports.routerRedux = require('connected-react-router');